// extracted by mini-css-extract-plugin
module.exports = {"parsingOptions":"ParsingOptions_parsingOptions__1Yu9X","refresh-button":"ParsingOptions_refresh-button__2ZTzo","separator-preview":"ParsingOptions_separator-preview__2pp3s"};